import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrow = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 240,
	height: 440,
	viewBox: "0 0 240 440",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M9.88357 430.108C22.9006 443.125 44.0072 443.125 57.0239 430.108L219.937 267.032C245.951 240.995 245.941 198.802 219.917 172.775L56.9039 9.763C43.8872 -3.25433 22.7806 -3.25433 9.76325 9.763C-3.25442 22.7807 -3.25442 43.886 9.76325 56.9037L149.284 196.425C162.304 209.442 162.304 230.548 149.284 243.565L9.88357 382.968C-3.13409 395.985 -3.13409 417.088 9.88357 430.108Z" })
});
export default SvgArrow;
